import React, { useState, useEffect } from 'react';
import useUserAccounts, { Accounts } from 'sdk/hooks/user/useUserAccounts';
import { Input } from 'components/shared/Input';
import AuthModal from 'components/shared/modals/AuthModal';
import Info from 'components/shared/Info';
import { validateEmail } from 'sdk/utils/validation'
import Button from 'components/shared/Button';
import { StringConstant } from 'utils/Constants';
import styles from './PassReset.module.scss';

type HandleNext = (params: Accounts) => void
type EmailViewProps = {
  handleNext: HandleNext
  onClose: () => void,
  onBack: () => void,
  loading: boolean,
}

function EmailView({
  handleNext,
  onClose,
  onBack,
  loading,
}: EmailViewProps) {
  const [emailError, setEmailError] = useState<boolean>(false)
  const [email, setEmail] = useState('')
  const [isSent, setIsSent] = useState(false)
  const [error, setError] = useState<string>('')
  const time = false
  const {
    mutate: getAccounts,
    data: getAccountsData,
    isSuccess: isGetAccountsSuccess,
    isError: isGetAccountsError,
    error: getAccountsError,
    reset: resetGetAccounts,
  } = useUserAccounts({ email: email.toLowerCase() })

  useEffect(() => {
    if (isGetAccountsSuccess) {
      handleNext(getAccountsData)
      resetGetAccounts();
    }
  }, [isGetAccountsSuccess])

  useEffect(() => {
    if (isGetAccountsError) {
      // @ts-ignore
      setError(getAccountsError?.message)
      resetGetAccounts();
    }
  }, [isGetAccountsError])

  const isValidEmailDomain = (value: string) => {
    if (!value.includes('@') || !value.includes('.')) {
      return true
    }
    // @ts-ignore
    if (value.split('.').length > 1 && value.split('.').at(-1)?.length < 8) {
      return true
    }
    return false
  }

  const handleEmailChange = (e: React.FormEvent<HTMLInputElement>) => {
    const target = e.target as HTMLInputElement
    const value = target?.value
    if (isValidEmailDomain(value)) {
      setEmail(value)
      setIsSent(false)
      setEmailError(false)
      setError('')
    }
  }

  const isEmailValid = validateEmail(email)

  return (
    <AuthModal
      onClose={onClose}
      onBack={onBack}
      title="Reset Password"
      showLogo
    >

      <Input
        className={styles.margin20}
        type="email"
        value={email}
        onChange={handleEmailChange}
        onBlur={() => setEmailError(!isEmailValid)}
        placeholder="Enter your email"
        error={emailError || Boolean(error)}
        errorMessage={emailError ? 'Invalid email' : StringConstant.RESET_PASSWORD_ERROR_MEESAGE}
        wide
        white
      />

      <Info white>
        <span>
          Enter the
          {' '}
          <em>Email</em>
          {' '}
          associated with your account and we&apos;ll send instructions to reset your password
        </span>
      </Info>

      <Button
        className={styles.margin20}
        disabled={!isEmailValid || Boolean(isSent)}
        onClick={() => {
          getAccounts()
          setIsSent(true)
        }}
        wide
        black
        loading={loading}
      >
        Send Link
      </Button>

      {(isSent && time) ? (
        <span className={styles.timerRow}>
          <span className={styles.wasSent}>link was sent</span>
          {time ? (
            <span>
              Resend link in
              {' '}
              <span className={styles.confirmInfoTime}>{time}</span>
              s
            </span>
          ) : null}
        </span>
      ) : null}
    </AuthModal>
  )
}

export default EmailView
